module.exports = function () {
    function timeout(cb, delay){
        return setTimeout(cb, delay);
    }
    timeout.clear = function(t){
        return clearTimeout(t);
    };
    return timeout;
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/jpex-defaults/src/$timeout.js
// module id = xRHi
// module chunks = 0